<script>
import classModifierMixin from './mixins/class-modifier-mixin'

export default {
	name: 'BaseModal',
	props: {
		modalName: {
			type: String
		},
		title: {
			type: String,
			default: null
		}
	},
	mixins: [classModifierMixin]
}
</script>

<template>
	<modal :name="modalName" v-bind="$attrs" :classes="[ 'base-modal', modifierClasses ]">
		<div class="base-modal__title" v-if="title">
			{{ title }}
		</div>
		<slot></slot>
	</modal>
</template>

<style lang="scss">
	.base-modal {
        background-color: var(--surface-colour);
		border-radius: var(--border-radius);
        color: var(--on-surface);
		&--primary {
			background-color: var(--primary-colour);
            color: var(--on-primary);
			padding: 0 0.5rem 1rem 0.5rem;
		}
		&--flex-column {
			display: flex;
			flex-direction: column;
			justify-content: space-evenly;
			align-items: center;
		}
		&--bg-secondary {
			background-color: var(--accent-variant-light);
			color: var(--on-accent);
		}
		&--center {
			text-align: center;
		}
		&--padding-1rem {
			padding: 1rem;
		}
		&--padding-2rem {
			padding: 2rem;
		}
		&--height-60 {
			height: 60vh;
		}
		&__title {
			font-size: 1.5rem;
			font-weight: bold;
			margin-bottom: 1rem;
			text-align: center;
			@media (max-width: 350px) {
				font-size: 1.4rem;
			}
			@media (orientation: landscape) {
				margin-bottom: 0.5rem;
			}
		}
	}
</style>
